import LoyaltyBanner from "../../../LoyaltyBanner";
import image from "../../../LoyaltyBanner/Tier_3_Cluster.webp";
import PropTypes from "prop-types";
import { withTranslation } from "../../../translation";

const BannerContent = ({ formatTranslation }) => {
  const buttonUrl =
    "https://www.asos.com/discover/our-apps/?campaign=earlyAccessSale-plpBanner";

  return (
    <LoyaltyBanner
      header={formatTranslation("early_access_to_sale_banner_title")}
      copy={formatTranslation("early_access_to_sale_banner_description")}
      buttonCopy={formatTranslation("early_access_to_sale_banner_cta")}
      buttonUrl={buttonUrl}
      imagePath={image}
    />
  );
};

BannerContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(BannerContent);
